import React from "react";

const AboutAreaFive = () => {
  return (
    <>
      {/* =============== About Area Five End ===============*/}
      <div className="about-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner">
                <img
                  className="main-img"
                  src="https://agiletechwp.wowtheme7.com/wp-content/uploads/2023/03/15-1.png"
                  alt="Startup founders collaborating on product development"
                />
              </div>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0 ps-xl-5">
                <h6 className="sub-title-sky-blue">How We Help Founders Build With Confidence</h6>
                <h2 className="title">A Proven Process for Building Fundable Companies</h2>
                <p className="content mb-4">
                 Evolvelab works hands-on with founders through a structured, repeatable process designed to reduce uncertainty and accelerate progress at every stage.

                Our approach combines:
                <ul>
                  <li>Strategic clarity to define the right direction</li>
                  <li>Accelerated execution to build momentum early</li>
                  <li>Capital alignment to support growth at the right time</li>
                </ul>

                We guide founders through the most critical phases of the startup journey:
                <ul>
                  <li>Turning vision into a clear, fundable roadmap</li>
                  <li>Aligning product, execution, and milestones</li>
                  <li>Avoiding costly missteps that slow growth or weaken future funding</li>
                </ul>

                There is no generic formula for success.
                That’s why Evolvelab adapts its process to your stage, your goals, and your reality—while maintaining the discipline investors and partners expect.

                The result: stronger execution, better decisions, and companies built to scale.
                </p>
                {/* <Link
                  className="btn btn-base-color border-radius-5"
                  to="/about"
                >
                  Discover More <FaArrowRight />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =============== About Area Five End ===============*/}
    </>
  );
};

export default AboutAreaFive;
